import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalFinancingDto } from "../dto/solar-proposal-financing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Credit Human Loan Products, the selection, and the Quote read against the
 * stored pricing inputs. A pure read: it never prices or refreshes.
 */
export default function useSolarProposalFinancing(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<SolarProposalFinancingDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.financing(proposalId ?? ``),
    queryFn: () => solarProposalService.getFinancing(proposalId ?? ``),
    enabled: Boolean(proposalId) && enabled,
    retry: retrySolarRead,
  })
}
